/**
 * Shared helpers for Access-style data tables.
 *
 * Format khớp Sale Contract (`ContractListView.tsx`) / Purchase Local P (`LocalPListPage.tsx`):
 * - Footer "Total" row hiển thị tổng các cột numeric (trừ giá/FX/percent/avg/id).
 * - Số nguyên hiển thị có dấu phẩy phân nhóm, số thực 2 chữ số sau dấu phẩy.
 */

export function formatAccessNumber(value: number): string {
  if (!Number.isFinite(value)) return ''
  if (Number.isInteger(value)) return value.toLocaleString('en-US')
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function sumNumericColumn<T>(rows: readonly T[], key: keyof T): number | null {
  let total = 0
  let count = 0
  for (const row of rows) {
    const value = row[key]
    if (typeof value !== 'number' || !Number.isFinite(value)) continue
    total += value
    count += 1
  }
  return count > 0 ? total : null
}
